import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function SmoothiesPage() {

    const heroData = [
        {
          title: "Smoothies & Milkshakes",
          content: "Indulge in the perfect blend of flavor and freshness with our smoothies and milkshakes. Crafted from ripe fruits, creamy dairy, and delightful toppings, our drinks are a treat for all ages. Whether you crave a healthy, refreshing smoothie or a rich, indulgent milkshake, we have the perfect drink to brighten your day.",
          image: images.SmoothiesHeroImage, 
        },
      ];

    const SmoothiesData = [
      {
        name: "Berry Bliss",
        price: 0,
        image: [
          images.Smoothie1,
        ]
      },
      {
        name: "Tropical Sunrise",
        price: 0,
        image: [
          images.Smoothie2,
        ]
      },
      {
        name: "Mango",
        price: 0,
        image: [
          images.Smoothie3,
        ]
      },
      {
        name: "Banana & Date",
        price: 0,
        image: [
          images.Smoothie4,
        ]
      },
    ]

    const MilkshakesData = [
      {
        name: "Classic Vanilla",
        price: 0,
        image: [
          images.Milkshake1,
        ]
      },
      {
        name: "Double Chocolate",
        price: 0,
        image: [
          images.Milkshake2,
        ]
      },
      {
        name: "Strawberry Dream",
        price: 0,
        image: [
          images.Milkshake3,
        ]
      },
      {
        name: "Cookies & Cream",
        price: 0,
        image: [
          images.Milkshake4,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Double Chocolate",
        image1: [
          images.Milkshake2,
        ],
        content1: "",
        name2: "Cookies & Cream",
        image2: [
          images.Milkshake4,
        ],
        content2: ""
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={SmoothiesData} title="Smoothies" />
            <ProductsSection productData={MilkshakesData} title="Milkshakes" />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
